module.exports = __webpack_public_path__ + "img/shp_mob_diagram.png";